import { z } from 'zod';

export const studentSchema = z.object({
  alunoId: z.number(),
  nomeAluno: z.string(),
});

export type Student = z.infer<typeof studentSchema>;

export const studentsPageResponseSchema = z
  .object({
    content: z.array(studentSchema),
  })
  .transform((val) => val.content);

export type StudentsResponse = Student[];
